// extracted by mini-css-extract-plugin
export default {"headerBottom":"HeaderBottom_headerBottom__7+4zl"};